import React, { FC } from 'react';
import classnames from 'classnames';
import { Tooltip, HelpIcon, Asset } from '@clearcover/atlas';
import { FormInput, Column, Row } from 'Shared/components';
import { AddVehicleFormValues } from '.';
import styles from './styles.module.css';
import { useFormikContext } from 'formik';
import { CoverageFormOptionType } from '@clearcover/core-app-types';

type VehicleCoverageType = {
  coverages: Array<CoverageFormOptionType>;
  endorsements: Array<CoverageFormOptionType>;
};

export const VehicleCoverage: FC<VehicleCoverageType> = ({
  coverages,
  endorsements,
}) => {
  const {
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormikContext<AddVehicleFormValues>();

  const mapToCoverageRow = (coverages: Array<CoverageFormOptionType>) => {
    return coverages.map(coverage => {
      const formKey = coverage.identifier;

      return (
        <Row className={styles.row} key={formKey}>
          <Column className={styles.addVehicleTooltip}>
            <span className={styles.coverageHeader}>{coverage.label}</span>
            {coverage.description && (
              <>
                <Tooltip
                  tooltip={<span>{coverage.description}</span>}
                  position="right"
                >
                  <Asset
                    icon={HelpIcon}
                    description={`${coverage.label} information`}
                    height={16}
                    width={16}
                    className={styles.helpIcon}
                  />
                </Tooltip>
              </>
            )}
          </Column>
          <Column>
            <FormInput
              variant="selectAutocomplete"
              name={`coverages.${formKey}`}
              onChange={value => setFieldValue(`coverages.${formKey}`, value)}
              onBlur={handleBlur}
              value={`${values.coverages[formKey]}`}
              errorMessage={
                touched.coverages && touched.coverages[formKey]
                  ? errors.coverages && errors.coverages[formKey]
                  : undefined
              }
              label="Coverage options"
              data-testid={formKey}
              options={coverage.coverageOptions}
            />
          </Column>
        </Row>
      );
    });
  };

  return (
    <div
      className={classnames(styles.section, styles.coverages)}
      data-testid="vehicle-modal-coverage"
    >
      <h1>Coverage</h1>
      {mapToCoverageRow(coverages)}
      {mapToCoverageRow(endorsements)}
    </div>
  );
};
